import { useCallback, useEffect, useState } from 'react';

export const useFormField = ({
  name,
  initialValue = '',
  validator,
  required = true,
  onErrorChange,
}) => {
  const [value, setValue] = useState(initialValue);
  const [touched, setTouched] = useState(false);

  const validate = useCallback(
    (val) => {
      if (!required) return '';
      return validator ? validator(val) : '';
    },
    [validator, required],
  );

  const error = validate(value);

  useEffect(() => {
    if (onErrorChange) {
      onErrorChange(name, error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    setTouched(true);
  };

  const reset = () => {
    setValue('');
    setTouched(false);
  };

  return {
    value,
    onChange: handleChange,
    onBlur: handleBlur,
    touched,
    error,
    reset,
    setValue,
    setTouched,
  };
};
